import React from "react"
import { Accordion, Panel } from "react-bootstrap"

export default function FAQ() {
	return (
		<Accordion className="faq-accordion" defaultActiveKey="1">
			<Panel eventKey="1" header="How does this work?">
				<p>
					Crypto Portfolio Tracker will load your order history from the
					exchange using the API information in the <b>Accounts</b> panel. Then,
					it will calculate and display the book value, average cost, and
					unrealized gain/loss for your assets.
				</p>
			</Panel>
			<Panel eventKey="2" header="How do I create an account?">
				<p>
					Click the <b>Sign in</b> button at the top-right of the page.
				</p>
			</Panel>
			<Panel
				eventKey="2.1"
				header="Can I reuse an API key from another application?"
			>
				<p>
					No. Crypto Portfolio Tracker must have a unique API key. This is
					because the exchange APIs use nonce values to ensure sequential
					access. If two distinct applications try to use the API key at the
					same time, the nonce values will be out of order, causing errors.
				</p>
			</Panel>
			<Panel
				eventKey="2.2"
				header="Why do Bittrex accounts require the fullOrders.csv file?"
			>
				<p>
					The Bittrex API returns only the last 30 days of trade history. To
					calculate the average cost for your assets older than this period, the{" "}
					<b>fullOrders.csv</b> file is needed to get the purchase price of your
					assets.
				</p>
				<p>
					You only need to submit this file once. After that, your trades are
					automatically synced as long as you visit Crypto Portfolio Tracker at
					least once every 30 days.
				</p>
			</Panel>
			<Panel eventKey="3" header="Why does an asset show an N/A value?">
				<p>
					The exchanges provide two sets of information: the account balance and
					the trade history. If the asset quantities in these two sets do not
					match, then the book value can't be calculated, because some quantity
					of the asset has an unknown cost basis. N/A will be shown for these
					values.
				</p>
				<p>
					These exchange actions generally cause your account balance to not
					match your trade history:
				</p>
				<ul>
					<li>Asset transferred into the exchange</li>
					<li>Asset transferred out of the exchange</li>
					<li>Asset received from a blockchain fork (e.g. BCH from BTC)</li>
					<li>Asset received for free (e.g. XLM distribution)</li>
					<li>Asset renamed or converted (e.g. ANS to NEO)</li>
				</ul>
				<p>
					You can manually set the average cost for any asset that has N/A
					values.
				</p>
			</Panel>
			<Panel
				eventKey="4"
				header="Why does my portfolio book value change over time?"
			>
				<p>
					For the purpose of portfolio book value calculation, any asset that
					doesn't have a book value will be counted at its market value. Thus,
					if the market value for this asset increases, the portfolio book value
					will increase as well. Vice versa occurs for a decrease in the market
					value.
				</p>
			</Panel>
			<Panel eventKey="5.1" header="Do you have an iOS or Android mobile app?">
				<p>
					The Crypto Portfolio Tracker website is mobile friendly and works on
					iOS and Android web browsers.
				</p>
				<p>
					However, we're also working on native mobile apps. This is one of our
					most requested features. Follow{" "}
					<a
						href="https://twitter.com/crypto_port"
						target="_blank"
						rel="noopener noreferrer"
					>
						<b>@crypto_port</b>
					</a>{" "}
					to get notified when it's available!
				</p>
			</Panel>
			<Panel
				eventKey="6"
				header="What is your privacy policy and terms of service?"
			>
				<b>Crypto Portfolio Tracker Policy</b>
				<ol>
					<li>
						Your API keys are used to retrieve information from the exchanges
						solely for the purpose of displaying information to you in Crypto
						Portfolio Tracker.
					</li>
					<li>You may delete your API keys at any time.</li>
					<li>
						Crypto Portfolio Tracker <b>does not</b> sell retrieved information
						to any third parties. Our app is supported directly by our users
						through paid subscriptions.
					</li>
					<li>
						Crypto Portfolio Tracker is for informational use only and is not
						intended for tax or accounting purposes.
					</li>
					<li>
						Any changes to this policy will be posted on{" "}
						<a
							href="https://cryptoportfoliotracker.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							https://cryptoportfoliotracker.com
						</a>.
					</li>
				</ol>
				<i>
					CRYPTO PORTFOLIO TRACKER IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS
					ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
					WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
					AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
					DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
					PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
					TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
					PERFORMANCE OF THIS SOFTWARE.
				</i>
			</Panel>
			<Panel
				eventKey="7"
				header="I have another question, problem, or feature request!"
			>
				<p>
					Feel free to chat with us! Click on the chat icon in the bottom-right
					of the screen. We are active and respond to all chat messages within 1
					business day, if not sooner!
				</p>
			</Panel>
		</Accordion>
	)
}



// WEBPACK FOOTER //
// ./src/FAQ.js